import React from "react";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import { useMyEntitlements } from "@seabrookstudios/pitch2table";
import { AlwaysOnAppLink } from "../styleguide/AppLink";
import { Path } from "../Path";

/**
 * A header component that displays an upgrade message for non-premium members
 * in the files tab, highlighting additional storage and PNP sharing capabilities.
 * @returns {React.JSX.Element}
 */
export const NonMemberUpgradeHeader = () => {
  const { data: entitlements, isLoading } = useMyEntitlements();

  if (isLoading || !entitlements || entitlements.isMember) {
    return <></>;
  }

  return (
    <Box px={2} pb={1}>
      <Alert severity="info">
        Get 20x more storage and share print and play files with publishers by{" "}
        <AlwaysOnAppLink to={Path.Premium}>upgrading to premium</AlwaysOnAppLink>.
      </Alert>
    </Box>
  );
};
